import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { getWorkspaceDetailSettingsUrl } from '@futrli/shared-services';

import coreStyles from '../../core/common.scss';
import { useReconnectDatasource } from '../../hooks/use-reconnect-datasource';
import { useSxpContext } from '../../core/sxp-context/sxp-context';

const NoDatasourceConnectedFC = () => {
  const { workspaceId: tempWorkspaceId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const { onlyExternalOrgs } = useSxpContext();
  const { reconnect, isReconnecting } = useReconnectDatasource();

  const navigate = useNavigate();

  const handleOrgSettingsButtonClick = useCallback(() => {
    navigate(getWorkspaceDetailSettingsUrl(workspaceId));
  }, [workspaceId, navigate]);

  return (
    <div className={classNames(coreStyles.allCaughtUp, coreStyles.predict)}>
      <Icon type="warning" fontSize="extra-large" />
      <Typography variant="h1" mt="8px" fontWeight="500">
        <FormattedMessage
          id="predict.connection_issues_try_connecting"
          defaultMessage="Looks like there is a connection issue.{br}Let's retry connecting to your data source.{br}Click the button below to start the process."
          values={{ br: <br /> }}
        />
      </Typography>
      {onlyExternalOrgs ? (
        <Button buttonType="primary" mt="24px" onClick={() => reconnect()} disabled={isReconnecting}>
          <FormattedMessage id="common.reconnect" defaultMessage="Reconnect" />
        </Button>
      ) : (
        <Button buttonType="primary" mt="24px" onClick={handleOrgSettingsButtonClick}>
          <FormattedMessage id="common.organisation_settings" defaultMessage="Organisation settings" />
        </Button>
      )}
    </div>
  );
};

export const NoDatasourceConnected = React.memo(NoDatasourceConnectedFC);
